export default __webpack_public_path__ + "static/media/UserEndedMeeting.00bfc8ae.mp3";